(function ($) {
  /**
   * Home Page Specific Animations
   * This file defines only the logic for individual sections.
   * The core scroll-jacking is managed by pageSnaps.js.
   */
  $(document).ready(function () {
    const isDesktop = typeof Foundation !== "undefined" && Foundation.MediaQuery.atLeast("large");

    // ─────────────────────────────────────────────────────────────────────────
    // SECTION-SPECIFIC REVEALS
    // ─────────────────────────────────────────────────────────────────────────

    // About Us Step 0: Scrolled Text Reveal
    function buildAboutUsStep0(el) {
      const introEl = el.querySelector(".about-us-intro");
      if (!introEl) return null;

      if (!el._splitText) {
        el._splitText = new SplitText(introEl, { type: "words,chars", charsClass: "char", wordsClass: "word" });
        gsap.set(el._splitText.chars, { opacity: 0, filter: "blur(20px)" });
      }

      const chars = el._splitText.chars, N = chars.length, W = 0.12, totalDur = 1.5;
      const tl = gsap.timeline({ paused: true });
      tl.fromTo(chars,
        { opacity: 0, filter: "blur(20px)" },
        { opacity: 1, filter: "blur(0px)", duration: W * totalDur, ease: "none", stagger: { each: (totalDur * (1 - W)) / N } }
      );
      return tl;
    }

    // About Us Step 1: Link Reveal
    function buildAboutUsStep1(el) {
      const linkChild = el.querySelector(".about-us-link > *");
      const tl = gsap.timeline({ paused: true });
      if (linkChild) tl.fromTo(linkChild, { yPercent: 100 }, { yPercent: 0, duration: 0.8, ease: "power2.out" });
      return tl;
    }

    // Slogan Text Fade
    function buildSloganTextFade(el) {
      const sloganText = el.querySelector(".slogan-text");
      if (!sloganText) return null;
      const tl = gsap.timeline({ paused: true });
      tl.fromTo(sloganText, { opacity: 0 }, { opacity: 1, duration: 0.6, ease: "power2.out" });
      return tl;
    }

    // Slogan Scrub (Images)
    function buildSloganScrub(el) {
      const img1 = el.querySelector(".image-1"), img2 = el.querySelector(".image-2"), img3 = el.querySelector(".image-3"), img4 = el.querySelector(".image-4");
      if (!img1) return null;
      const images = [img1, img2, img3, img4];
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;
      const startSize = isPortrait ? "1vw" : "1svh", endSize = isPortrait ? "100vw" : "80svh";

      gsap.set(images, { opacity: 0, filter: "blur(16px)", position: "absolute", top: "50%", left: "50%", xPercent: -50, yPercent: -50, x: 0, y: 0, maxWidth: startSize, maxHeight: startSize });

      const tl = gsap.timeline({ paused: true });
      const staggerTime = 0.15; // Offset between each image starting
      const moveDur = isDesktop ? 0.7 : 0.7;      // Duration of individual flight
      const dist = isDesktop ? "90svh" : "100vw";      // Distance to just exit the screen to prevent dead scrolling

      images.forEach((img, i) => {
        const startTime = i * staggerTime;
        // Direction multipliers for 45 deg: Top-Left, Top-Right, Bottom-Left, Bottom-Right
        const dx = (i === 1 || i === 3) ? 1 : -1;
        const dy = (i === 2 || i === 3) ? 1 : -1;

        // Unblur and fade in during the first 25% of its flight
        tl.to(img, {
          opacity: 1,
          filter: "blur(0px)",
          duration: moveDur * (isDesktop ? 0.1 : 0.25),
          ease: "none"
        }, startTime);

        // Position and Scale over the full duration
        tl.to(img, {
          x: dx > 0 ? dist : `-${dist}`,
          y: dy > 0 ? dist : `-${dist}`,
          maxWidth: endSize,
          maxHeight: endSize,
          duration: moveDur,
          ease: "none"
        }, startTime);
      });

      return tl;
    }

    /**
     * Innovation Intro (Primary entrance reveal)
     */
    function buildInnovationIntro(el, state) {
      const textEl = el.querySelector(".innovation-text"), subtextEl = el.querySelector(".innovation-subtext");
      if (!textEl || !subtextEl) return null;

      const tl = gsap.timeline({ paused: true, onComplete: () => { if (state) state.hasPlayed = true; } });
      if (textEl._splitText) {
        tl.to(textEl._splitText.lines, { yPercent: 0, duration: 0.6, ease: "power2.out", stagger: 0.1 });
      }
      if (subtextEl._splitText) {
        tl.to(subtextEl._splitText.lines, { yPercent: 0, duration: 0.6, ease: "power2.out", stagger: 0.1 }, "+=0.1");
      }

      const cardsContainer = el.querySelector(".innovation-cards");
      if (cardsContainer) {
        tl.to(cardsContainer, { opacity: 1, duration: 0.5, ease: "power2.out" }, "+=0.1");
      }
      
      const firstCard = el.querySelector(".innovation-cards .card");
      if (firstCard && !isDesktop) {
        revealInnovationCard(firstCard, tl, ">");
      }
      return tl;
    }

    /**
     * Card Content Reveal (Home style)
     */
    function revealInnovationCard(card, tl, offset = 0) {
      if (!card) return;
      const title = card.querySelector(".innovation-card-title"), desc = card.querySelector(".innovation-card-description");
      if (title?._splitText) tl.fromTo(title._splitText.lines, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: "power2.out" }, offset);
      if (desc?._splitText) tl.fromTo(desc._splitText.lines, { yPercent: 100 }, { yPercent: 0, duration: 0.6, ease: "power2.out", stagger: 0.1 }, (offset === ">" || offset === "<") ? ">" : offset + 0.1);
    }

    /**
     * Card Content Reset
     */
    function resetInnovationCard(card, tl, offset = 0) {
      if (!card) return;
      const t = card.querySelector(".innovation-card-title"), d = card.querySelector(".innovation-card-description");
      const lines = [];
      if (t?._splitText) lines.push(...t._splitText.lines);
      if (d?._splitText) lines.push(...d._splitText.lines);
      if (lines.length) {
        if (tl) tl.set(lines, { yPercent: 100 }, offset);
        else gsap.set(lines, { yPercent: 100 });
      }
    }

    // By The Number
    function buildByTheNumber(el) {
      const textEl = el.querySelector(".by-the-number-text"), stats = el.querySelectorAll(".statistic"), imageWrapper = el.querySelector(".by-the-number-image");
      if (!textEl) return null;

      if (!textEl._splitText) {
        textEl._splitText = new SplitText(textEl, { type: "lines" });
        $(textEl._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
      }
      gsap.set(textEl._splitText.lines, { yPercent: 100 });

      stats.forEach((stat) => {
        const border = stat.querySelector(".border-top"), caption = stat.querySelector(".caption"), num = stat.querySelector(".statistic-number");
        if (num && !num.dataset.wrapped) { $(num).wrap('<div style="overflow: hidden; display: block;"></div>'); num.dataset.wrapped = "true"; }
        if (caption && !caption.dataset.wrapped) { $(caption).wrap('<div style="overflow: hidden; display: block;"></div>'); caption.dataset.wrapped = "true"; }
        if (border) gsap.set(border, { width: 0 });
        if (caption) gsap.set(caption, { yPercent: 100 });
        if (num) gsap.set(num, { yPercent: 100 });
      });

      if (imageWrapper) gsap.set(imageWrapper, { opacity: 0, y: 40 });

      const tl = gsap.timeline({ paused: true });
      tl.to(textEl._splitText.lines, { yPercent: 0, duration: 0.6, ease: "power2.out", stagger: 0.1 });

      const baseTime = tl.duration() + 0.1;
      stats.forEach((stat) => {
        const border = stat.querySelector(".border-top"), caption = stat.querySelector(".caption"), num = stat.querySelector(".statistic-number");
        const startTime = baseTime; // Remove the stagger completely!
        if (border) tl.to(border, { width: "100%", duration: 0.25, ease: "power2.out" }, startTime);
        if (caption) tl.to(caption, { yPercent: 0, duration: 0.2, ease: "power2.out" }, startTime);
        if (num) tl.to(num, { yPercent: 0, duration: 0.6, ease: "power2.out" }, startTime + 0.2);
      });

      if (imageWrapper) tl.to(imageWrapper, { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }, ">+0.1");
      return tl;
    }

    // ─────────────────────────────────────────────────────────────────────────
    // SLIDE ANIMATION REGISTRY
    // ─────────────────────────────────────────────────────────────────────────
    const snapsConfig = {
      sectionsSelector: ".outer-container > section",
      snapDuration: 0.9,
      hasHero: true,
      hasFooterSnap: !isDesktop,
      excludeLastSections: isDesktop ? 1 : 0
    };

    const slideAnimations = [
      /* 0: About Us */
      {
        onInit: (el) => {
          const image = el.querySelector(".about-us-image");
          if (image) gsap.set(image, { opacity: 0, y: 40 });
        },
        onEnter: (el, direction) => {
          const image = el.querySelector(".about-us-image");
          if (image) {
            if (direction === "down") {
              gsap.fromTo(image, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out", delay: 0.1 });
            } else {
              // If entered from below (via url hash bypass), it may still be stuck at opacity:0 from onInit.
              // A gsap.to automatically fades it in if missing, or does absolutely nothing if already visible!
              gsap.to(image, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" });
            }
          }
        },
        onLeave: (el, direction) => {
          if (direction === "up") {
            const image = el.querySelector(".about-us-image");
            if (image) gsap.to(image, { opacity: 0, y: 40, duration: 0.4, ease: "power2.inOut" });
          }
        },
        steps: [
          { build: buildAboutUsStep0, scrub: true, scrubMultiplier: isDesktop ? 1 : 1.75 },
          { build: buildAboutUsStep1 }
        ]
      },
      /* 1: Slogan */
      {
        steps: [
          { build: buildSloganTextFade, autoPlayDown: true, autoDownDelay: 1000, autoUpJump: true },
          { build: buildSloganScrub, scrub: true, scrubMultiplier: isDesktop ? 0.6 : 1.6 }
        ]
      },
      /* 2: Innovation */
      {
        onInit: (el) => {
          // Pre-hide text and container here so it's invisible during scroll
          const textEl = el.querySelector(".innovation-text"), subtextEl = el.querySelector(".innovation-subtext");
          if (textEl && !textEl._splitText) {
            textEl._splitText = new SplitText(textEl, { type: "lines" });
            $(textEl._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
            gsap.set(textEl._splitText.lines, { yPercent: 100 });
          }
          if (subtextEl && !subtextEl._splitText) {
            subtextEl._splitText = new SplitText(subtextEl, { type: "lines" });
            $(subtextEl._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
            gsap.set(subtextEl._splitText.lines, { yPercent: 100 });
          }
          const cardsContainer = el.querySelector(".innovation-cards");
          if (cardsContainer) gsap.set(cardsContainer, { opacity: 0 });

          const container = el.querySelector(".innovation-cards"),
                inner = el.querySelector(".innovation-cards-inner"),
                cards = el.querySelectorAll(".card");
          if (!container || !inner || !cards.length) return;

          if (!isDesktop) {
            const h = container.clientHeight;
            gsap.set(cards, { height: h, display: "block", position: "relative", marginBottom: 0 });
          } else {
            gsap.set(cards, { display: "block", position: "relative", margin: "0 0 16px 0" });
          }

          cards.forEach(card => {
            const t = card.querySelector(".innovation-card-title"), d = card.querySelector(".innovation-card-description");
            if (t && !t._splitText) {
              t._splitText = new SplitText(t, { type: "lines" });
              $(t._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
            }
            if (d && !d._splitText) {
              d._splitText = new SplitText(d, { type: "lines" });
              $(d._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
            }
            if (!isDesktop) {
              resetInnovationCard(card);
            }
          });
        },
        onEnter: (el, direction, state) => {
          if (!state.hasPlayed) {
             const tl = buildInnovationIntro(el, state);
             if (tl) tl.play();
          }
        },
        steps: isDesktop ? [
          {
            build: (el) => {
              const inner = el.querySelector(".innovation-cards-inner"),
                    container = el.querySelector(".innovation-cards"),
                    cards = el.querySelectorAll(".card");
              const tl = gsap.timeline({ paused: true });
              tl.fromTo(inner, { y: 0 }, {
                y: () => {
                   let totalHeight = 0;
                   cards.forEach(c => { totalHeight += c.offsetHeight + 10; });
                   return -Math.max(0, totalHeight - container.clientHeight);
                },
                ease: "none"
              });
              return tl;
            },
            scrub: true,
            scrubMultiplier: 3
          }
        ] : [],
        subSlides: !isDesktop ? {
          selector: ".card",
          wrapperSelector: ".innovation-cards-inner",
          itemHeight: (el) => el.querySelector(".innovation-cards").clientHeight,
          tape: true,
          onSetTape: (el, subIdx, prevIdx, animate, tl, direction, state) => {
            const cards = el.querySelectorAll(".innovation-cards-inner .card");
            if (!cards.length) return;

            if (!animate) {
               cards.forEach(c => resetInnovationCard(c));
               const current = cards[subIdx];
               // Special case: Only reveal here if we are NOT on the very first entrance (let Intro handle that)
               // OR if we are scrolling UP into the section.
               if (current && (state.hasPlayed || direction === "up")) {
                  revealInnovationCard(current, gsap.timeline().play());
               }
               return;
            }

            const next = cards[subIdx], prev = prevIdx !== -1 ? cards[prevIdx] : null;
            if (prev && prev !== next) resetInnovationCard(prev, tl, 0.9);
            if (next) revealInnovationCard(next, tl, 1.0);
          }
        } : null
      },
      /* 3: By The Number */
      {
        steps: [
          { build: buildByTheNumber, autoPlayDown: true, autoDownDelay: 1000, autoUpJump: true }
        ]
      },
      /* 4: Featured Projects */
      {
        onEnter: (el, direction) => {
           if (direction === "up") return;
           const slideNumbers = el.querySelectorAll(".slide-number"), totalSlides = el.querySelector(".total-slides"), featuredSlides = el.querySelectorAll(".featured-slide");
           const tl = gsap.timeline({ delay: 0.2 });
           tl.fromTo([slideNumbers, totalSlides], { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: "power2.out" }, 0);
           if (featuredSlides.length > 0) {
              const f = featuredSlides[0], t = f.querySelector(".project-type .fp-mask-inner"), l = f.querySelector(".project-location .fp-mask-inner"), tit = f.querySelector(".featured-project-title .fp-mask-inner");
              if (t && l && tit) {
                 tl.fromTo([t, l], { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: "power2.out" }, 0.1);
                 tl.fromTo(tit, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: "power2.out" }, 0.6);
              }
           }
        },
        onInit: (el) => {
           const slideNumbers = el.querySelectorAll(".slide-number"), totalSlides = el.querySelector(".total-slides"), featuredSlides = el.querySelectorAll(".featured-slide");
           if (el.querySelector(".current-slide") && slideNumbers.length) gsap.set(el.querySelector(".current-slide"), { height: slideNumbers[0].offsetHeight });
           if (totalSlides && !totalSlides.dataset.wrapped) { $(totalSlides).wrap('<div style="overflow: hidden; display: block;"></div>'); totalSlides.dataset.wrapped = "true"; }
           gsap.set([slideNumbers, totalSlides], { yPercent: 100 });
           featuredSlides.forEach(slide => {
              [".project-type", ".project-location", ".featured-project-title"].forEach(sel => {
                 const target = slide.querySelector(sel);
                 if (target && !target.dataset.wrapped) {
                    const inner = document.createElement("div"); inner.className = "fp-mask-inner"; inner.style.display = "block";
                    while (target.firstChild) inner.appendChild(target.firstChild);
                    const mask = document.createElement("div"); mask.style.overflow = "hidden"; mask.style.display = "block"; mask.appendChild(inner);
                    target.appendChild(mask); target.dataset.wrapped = "true";
                 }
              });
           });
           gsap.set(el.querySelectorAll(".fp-mask-inner"), { yPercent: 100 });
        },
        subSlides: {
          selector: ".featured-slide",
          tape: true,
          tapeDelay: (snapsConfig.snapDuration / 0.9) * 0.3,
          wrapperSelector: ".slides-wrapper",
          onSetTape: (el, subIdx, prevIdx, animate, tl, direction, state) => {
            const slideNumbers = el.querySelectorAll(".slide-number"), featuredSlides = el.querySelectorAll(".featured-slide");
            if (!slideNumbers.length) return;
            const h = slideNumbers[0].offsetHeight;

            if (!animate) {
              gsap.set(slideNumbers, { y: -subIdx * h });
              featuredSlides.forEach((slide) => { slide.querySelectorAll(".fp-mask-inner").forEach(t => { if (gsap.getTweensOf(t).length === 0) gsap.set(t, { yPercent: 100 }); }); });
              const current = featuredSlides[subIdx];
              if (current && direction === "up") {
                 current.querySelectorAll(".fp-mask-inner").forEach(t => { if (gsap.getTweensOf(t).length === 0) gsap.set(t, { yPercent: 0 }); });
              }
              return;
            }

            tl.to(slideNumbers, { y: -subIdx * h, duration: snapsConfig.snapDuration, ease: "power2.inOut" }, (snapsConfig.snapDuration / 0.9) * 0.3);
            const prev = featuredSlides[prevIdx], next = featuredSlides[subIdx];
            if (prev && prev !== next) {
               tl.fromTo([prev.querySelector(".project-type .fp-mask-inner"), prev.querySelector(".project-location .fp-mask-inner")], { yPercent: 0 }, { yPercent: -100, duration: (snapsConfig.snapDuration / 0.9) * 0.5, ease: "power2.inOut", overwrite: "auto" }, 0)
                 .fromTo(prev.querySelector(".featured-project-title .fp-mask-inner"), { yPercent: 0 }, { yPercent: -100, duration: (snapsConfig.snapDuration / 0.9) * 0.5, ease: "power2.inOut", overwrite: "auto" }, 0.1);
            }
            if (next) {
               tl.fromTo([next.querySelector(".project-type .fp-mask-inner"), next.querySelector(".project-location .fp-mask-inner")], { yPercent: 100 }, { yPercent: 0, duration: (snapsConfig.snapDuration / 0.9) * 0.5, ease: "power2.out", overwrite: "auto" }, (snapsConfig.snapDuration / 0.9) * 0.84)
                 .fromTo(next.querySelector(".featured-project-title .fp-mask-inner"), { yPercent: 100 }, { yPercent: 0, duration: (snapsConfig.snapDuration / 0.9) * 0.5, ease: "power2.out", overwrite: "auto" }, (snapsConfig.snapDuration / 0.9) * 0.94);
            }
          }
        }
      }
    ];

    // ─────────────────────────────────────────────────────────────────────────
    // PRELOADER & INITIALIZATION
    // ─────────────────────────────────────────────────────────────────────────
    const $preloader = $('.preloader');
    const $preloaderBg = $preloader.find('.preloader-bg');
    snapsConfig.slideAnimations = slideAnimations;

    // Only run the preloader animation if it exists AND no URL hash is present
    if ($preloader.length && !window.location.hash) {
      
      // 0. HARD LOCK SCROLL IMMEDIATELY (Prevents native swiping/scrolling during preloader without using layout-shifting overflow:hidden)
      if (typeof window.lenis !== 'undefined') window.lenis.stop();
      document.body.classList.add("is-snapping");
      
      let canDismiss = false;
      let dismissed = false;
      let bounceTl;
      
      const dismissPreloader = () => {
        if (dismissed) return;
        dismissed = true;
        
        if (bounceTl) bounceTl.kill(); // Stop the bounce loop
        
        const tlDismiss = gsap.timeline({
          onComplete: () => {
            if (preloaderObserver) preloaderObserver.kill();
            if (typeof window.lenis !== 'undefined') window.lenis.start();
            $preloader.css({ 'pointer-events': 'none', 'display': 'none' });
            window.pageSnaps.init(snapsConfig);
          }
        });

        // Slide preloader UP
        tlDismiss.to($preloader, { 
          yPercent: -100, 
          duration: 1.2, 
          ease: "power3.inOut" 
        });
        
        // Animate Hero H2, Image Scales, and Header synchronously
        const $heroH2 = $('.hero .hero-content h2');
        const $mobileImg = $('.hero .mobile-hero-image');
        const $desktopImg = $('.hero .desktop-hero-image');
        const $headerEl = $('header');
        
        if ($mobileImg.length) tlDismiss.to($mobileImg, { scale: 1, duration: 1.5, ease: "power3.out" }, 0.2);
        if ($desktopImg.length) tlDismiss.to($desktopImg, { scale: 1, duration: 1.5, ease: "power3.out" }, 0.2);
        if ($heroH2.length) tlDismiss.to($heroH2, { opacity: 1, duration: 1.7, ease: "power2.out" }, 1.2);
        if ($headerEl.length) tlDismiss.to($headerEl, { opacity: 1, duration: 1.7, ease: "power2.out" }, 1.2);
      };

      const preloaderObserver = Observer.create({
        target: window,
        type: "wheel,touch,pointer",
        preventDefault: true,
        tolerance: 10,
        onUp: () => { if (canDismiss) dismissPreloader(); },
        onDown: () => { if (canDismiss) dismissPreloader(); }
      });
      
      const progressObj = { val: 0 };
      const $counterText = $preloader.find('.progress-counter');
      const $progressEl = $preloader.find('.progress');
      const $logoAnim = $preloader.find('.logo-animation');
      const $swipeUp = $preloader.find('.preloader-swipe-up');
      
      gsap.set($logoAnim, { opacity: 0 });
      gsap.set($swipeUp, { opacity: 0 });
      gsap.set('header', { opacity: 0 });
      gsap.set('.hero .hero-content h2', { opacity: 0 });
      gsap.set('.hero .mobile-hero-image, .hero .desktop-hero-image', { scale: 1.2 });

      const tl1 = gsap.timeline();
      
      // 1. Counter from 0 to 100 in 5 seconds (Randomized erratic jumps)
      let nextUpdateValue = 0;
      tl1.to(progressObj, {
        val: 100,
        duration: 5,
        ease: "power2.inOut",
        onUpdate: () => {
          if (progressObj.val >= 100) {
            if ($counterText.length) $counterText.text("100%");
          } else if (progressObj.val >= nextUpdateValue) {
            if ($counterText.length) $counterText.text(Math.floor(progressObj.val) + "%");
            // Set the next random threshold it has to cross before updating the DOM (jump by 3% to 15%)
            nextUpdateValue = progressObj.val + (Math.random() * 12 + 3);
          }
        }
      });

      // 2. Fade out progress, fade in logo
      tl1.to($progressEl, { opacity: 0, duration: 0.8 }, ">")
         .to($logoAnim, { opacity: 1, duration: 0.8 }, "<")
         .call(() => {
           const dotLottie = document.querySelector('dotlottie-wc');
           if (dotLottie && typeof dotLottie.dotLottie.play === 'function') {
             dotLottie.dotLottie.play();
           }
         }, null, ">");

      const lottieDuration = 3.5;
      tl1.to({}, { duration: lottieDuration });

      // 4. Background to transparent with blur
      tl1.to($preloaderBg, { 
        backgroundColor: "rgba(0,0,0,0)", 
        backdropFilter: "blur(24px)", 
        "-webkit-backdrop-filter": "blur(24px)",
        duration: 1.5,
        ease: "power2.inOut"
      }, ">");

      // 5. Shrink preloader margins, increase blur, round borders
      const margin = isDesktop ? 64 : 16;
      const $mobileImgShrink = $('.hero .mobile-hero-image');
      const $desktopImgShrink = $('.hero .desktop-hero-image');
      
      tl1.to($preloaderBg, {
        top: margin,
        left: margin,
        width: `calc(100% - ${margin * 2}px)`,
        height: `calc(100% - ${margin * 2}px)`,
        backdropFilter: "blur(64px)",
        "-webkit-backdrop-filter": "blur(64px)",
        borderRadius: 24,
        duration: 1.2,
        ease: "power3.inOut"
      }, ">");
      
      if ($mobileImgShrink.length) tl1.to($mobileImgShrink, { scale: 1.1, duration: 1.2, ease: "power3.inOut" }, "<");
      if ($desktopImgShrink.length) tl1.to($desktopImgShrink, { scale: 1.1, duration: 1.2, ease: "power3.inOut" }, "<");
      // 6. Fade in Swipe Up Indicator
      if ($swipeUp.length) tl1.to($swipeUp, { opacity: 1, duration: 0.8, ease: "power2.out" }, ">");

      // End of first timeline. Allow Observer to execute dismissal.
      tl1.call(() => {
        canDismiss = true;
        
        // Periodic bounce sequence
        bounceTl = gsap.timeline({ repeat: -1, repeatDelay: 2.8 });
        if ($swipeUp.length) {
          bounceTl.to($swipeUp, { y: -16, duration: 0.4, ease: "power2.out" })
                  .to($swipeUp, { y: 0, duration: 0.4, ease: "power2.in" });
        }
      });

    } else {
      // If no preloader exists, OR if a hash skips the preload sequence:
      if ($preloader.length) {
        $preloader.css('display', 'none');
      }
      window.pageSnaps.init(snapsConfig);
    }
  });
})(jQuery);
